import withAemIntegration from "../../../withAemIntegration";
import loadable from "../../../utils/loadable";
const Component = loadable(() =>
  import("@lexus.com/ui/dist/modules/LMexLeadForm")
);

const LexMexFormEditConfig = {
  emptyLabel: "Mexico Form",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const transformData = (props = {}) => {
  return {
    ...props,
    headline: props.heading,
    subHeading: props.subHeading,
    optionalText: props.optionalFieldLabel,
    formLabels: {
      ...props.inputFields,
    },
    serverErrorMessaging: {
      errorHeader: props.errorHeading,
      errorDescription: props.errorDescription,
    },
    privacyRightsHeading: props.privacyHeading,
    privacyRightsText: props.privacyText,
    submitCta: props.submitCta,
    confirmationHeadline: props.thankYou?.title,
    confirmationSubline: props.thankYou?.message,
    backToBrowseCta: props.thankYou?.backCta,
  };
};

const LexMexForm = (props) => {
  const data = transformData(props);
  return <Component {...data} />;
};

export default withAemIntegration("lexus/components/mexico/lex-mex-form")(
  LexMexForm,
  LexMexFormEditConfig
);
